// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input_inputWrapper__i4DXu","input":"Input_input__NS9Iv","error":"Input_error__ancKr","errorText":"Input_errorText__ylsww"};